import { useTranslation } from 'react-i18next';

import { Stack, Subtitle2 } from '@myphx-engineering/phx-design-system';

export const NoPricing = () => {
    const { t } = useTranslation();

    return (
        <>
            <Stack gap="xxs">
                <Stack gap="xxxs">
                    <Subtitle2>{t('noPrice.content.card')}</Subtitle2>
                </Stack>
            </Stack>
        </>
    );
};
